export const createTemplateResource = (resource: BucketResource) => ({
  strategy: {
    type: 'template',
    source: resource.id,
  },
  source: resource,
});

export const createTemplateDrivenStrategy = () => ({
  type: 'template',
});

export const createServerDrivenStrategy = (config: CropConfig) => ({
  type: 'server',
  ...config,
});

export const createClientDrivenStrategy = (
  horizontalAlign: HorizontalAlign = 'center',
  verticalAlign: VerticalAlign = 'center',
  parallaxEnabled: boolean = false
) => ({
  type: 'client',
  horizontalAlign,
  verticalAlign,
  parallaxEnabled,
});

export const createFixedWidthStrategy = (
  align: HorizontalAlign = 'center'
) => ({
  type: 'fixed',
  fullWidth: true,
  fullHeight: false,
  align,
  color: '#FFFFFF',
});

export const createFixedHeightStrategy = (align: VerticalAlign = 'center') => ({
  type: 'fixed',
  fullWidth: false,
  fullHeight: true,
  align,
  color: '#FFFFFF',
});



// WEBPACK FOOTER //
// ./src/modules/catalog/services/resources.js